// JavaScript Document

import { createFocusTrap } from "focus-trap";

const TOGGLES = document.querySelectorAll(".weblinx-panel-toggle");

TOGGLES.forEach((toggle) => {
    const LABELS  = toggle.dataset.label ? JSON.parse(toggle.dataset.label) : false;
    const ICONS   = toggle.dataset.icon ? JSON.parse(toggle.dataset.icon) : false;
    const LABEL   = toggle.querySelector(".weblinx-panel-toggle__label");
    const PANEL   = document.getElementById(toggle.getAttribute("aria-controls"));
    const OVERLAY = PANEL.querySelector(".weblinx-panel__overlay");
    const CLOSER  = PANEL.querySelector(".weblinx-panel__closer");

    /**
     * Set up a focus trap
     */
    const FOCUS_TRAP = createFocusTrap(PANEL, {
        clickOutsideDeactivates: true,
    });

    toggle.addEventListener("click", (e) => {
        e.preventDefault();

        const EXPANDED = toggle.getAttribute("aria-expanded") === "true";

        /**
         * Update the expanded state
         */
        toggle.setAttribute("aria-expanded", ! EXPANDED);

        /**
         * Change the label on interaction
         */
        if (LABELS && LABELS.open && LABELS.close) {
            LABEL.textContent = EXPANDED ? LABELS.open : LABELS.close;
        }

        /**
         * Change the icon on interaction
         */
        if (ICONS && ICONS.open && ICONS.close) {
            if (window.FontAwesomeConfig.keepOriginalSource) {
                toggle.querySelector("svg").nextSibling.remove();
            }

            toggle.querySelector("svg").remove();
            toggle.insertAdjacentHTML("afterbegin", `<i class="${EXPANDED ? ICONS.open : ICONS.close}"></i>`);
        }

        /**
         * Toggle the active state
         */
        document.documentElement.classList.toggle(`${toggle.getAttribute("aria-controls")}-is-active`);
        toggle.classList.toggle("is-active");
        PANEL.classList.toggle("is-active");

        if (EXPANDED) {
            if (PANEL.dataset.focusout && PANEL.dataset.focusout !== "false") {
                const FOCUS_ELEMENT = document.querySelector(PANEL.dataset.focusout);

                if (FOCUS_ELEMENT) {
                    FOCUS_ELEMENT.focus();
                } else {
                    console.warn(`Focus element "${PANEL.dataset.focusout}" not found for panel "${PANEL.id}"`);
                    toggle.focus();
                }
            } else {
                toggle.focus();
            }

            if (OVERLAY) {
                FOCUS_TRAP.deactivate();
                document.documentElement.style.overflow = "";
            }
        } else {
            if (PANEL.dataset.focus) {
                const FOCUS_ELEMENT = PANEL.querySelector(PANEL.dataset.focus);

                if (FOCUS_ELEMENT) {
                    FOCUS_ELEMENT.focus();
                } else {
                    console.warn(`Focus element "${PANEL.dataset.focus}" not found in panel "${PANEL.id}"`);
                    PANEL.focus();
                }
            } else {
                PANEL.focus();
            }

            if (OVERLAY) {
                FOCUS_TRAP.activate();
                document.documentElement.style.overflow = "hidden";
            }
        }

        /**
         * Emit an event
         */
        const EVENT = new CustomEvent("weblinx/panel/toggle", {
            detail: {
                expanded: ! EXPANDED,
                toggle,
                panel: PANEL
            }
        });

        toggle.dispatchEvent(EVENT);
    }, { passive: false });

    /**
     * Close the panel when the overlay is clicked
     */
    if (OVERLAY) {
        OVERLAY.addEventListener("click", (e) => {
            e.preventDefault();
            toggle.click();
        }, { passive: false });
    }

    /**
     * Close the panel when the close button is clicked
     */
    if (CLOSER) {
        CLOSER.addEventListener("click", (e) => {
            e.preventDefault();
            toggle.click();
        }, { passive: false });
    }

    /**
     * Close the panel when it loses focus
     */
    PANEL.addEventListener("focusout", (e) => {
        if (PANEL.dataset.focusout === "false") {
            return;
        }

        if (PANEL.classList.contains("is-active") && ! PANEL.contains(e.relatedTarget) && ! toggle.contains(e.relatedTarget)) {
            toggle.click();
        }
    });

    /**
     * Close the panel when the "escape" key is pressed
     */
    document.addEventListener("keydown", (e) => {
        if (PANEL.classList.contains("is-active") && e.key === "Escape") {
            toggle.click();
        }
    }, { passive: true });
});
